/* eslint-disable react/prop-types */
import React from "react";
import {
  makeStyles,
  Tooltip,
  Button,
  withStyles,
  useMediaQuery,
  Typography,
} from "@material-ui/core";
import MenuDialogComponent from "app/auth/utils/MenuDialogComponent";
import { CgMenuGridR } from "react-icons/cg";
import { ReactComponent as UserIcon } from "resources/user-icon.svg";
import ProfileDialogComponent from "./ProfileDialogComponent";

const useStyles = makeStyles(() => ({
  avatarImage: {
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    margin: "0 auto",
    display: "block",
  },
  logoutButton: {
    color: "#ffffff",
    marginTop: "10px",
  },
  link: {
    color: "white",
    width: "100%",
    textDecoration: "none",
    padding: "14px 0px",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "#474A64",
      // backgroundColor: "rgba(232, 104, 97, 0.5)",
    },
  },
  activeLink: {
    boxShadow: "0 2px 3px 0px black",
    backgroundColor: "#474A64",
    "&:hover": {
      cursor: "normal",
      backgroundColor: "#474A64",
    },
  },
  icon: {
    marginTop: "18px",
    width: "26px",
    height: "26px",
    color: "white",
    "& > path": {
      stroke: "white",
      fill: "white",
    },
  },
  userIcon: {
    marginTop: "18px",
    width: "20px",
    height: "20px",
    color: "white",
    "& > path": {
      stroke: "white",
      fill: "white",
    },
  },
  navIcon: {
    color: "inherit",
    marginTop: "0px",
  },
  tooltipTitle: {
    fontWeight: "bold",
    fontSize: "11px",
  },
  textProfile: {
    textTransform: "none",
    marginLeft: "10px",
  },
}));

const ProfileComponent = () => {
  const classes = useStyles();
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [
    confirmProfileDialogOpen,
    setConfirmProfileDialogOpen,
  ] = React.useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const handleDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleProfileDialogClose = () => {
    setConfirmProfileDialogOpen(false);
  };

  const handleProfileDialogOpen = () => {
    setConfirmProfileDialogOpen(true);
  };

  const handleDialogOpen = () => {
    setConfirmDialogOpen(true);
  };

  const StyledTooltip = withStyles(() => ({
    tooltip: {
      backgroundColor: "#484B5C",
    },
  }))(Tooltip);

  return (
    <>
      {!isSmallScreen && (
        <>
          <MenuDialogComponent
            open={confirmDialogOpen}
            handleClose={handleDialogClose}
          />
          <StyledTooltip
            title={
              <>
                <div className={classes.tooltipTitle}>Menu</div>
              </>
            }
            placement="right"
          >
            <Button onClick={() => handleDialogOpen()} className={classes.link}>
              <CgMenuGridR className={`${classes.icon} ${classes.navIcon}`} />
            </Button>
          </StyledTooltip>
        </>
      )}
      <ProfileDialogComponent
        open={confirmProfileDialogOpen}
        handleClose={handleProfileDialogClose}
      />
      <StyledTooltip
        title={
          <>
            <div className={classes.tooltipTitle}>Profile</div>
          </>
        }
        placement="right"
      >
        <Button
          data-testid="signOutButton"
          aria-label="Sign Out"
          className={classes.link}
          classes={{
            root: classes.logoutButton,
          }}
          size="small"
          disableRipple
          onClick={handleProfileDialogOpen}
        >
          <UserIcon
            className={`${classes.userIcon} ${classes.navIcon}`}
            data-testid="filogout"
          />
          {isSmallScreen && (
            <Typography className={classes.textProfile}>Profile</Typography>
          )}
        </Button>
      </StyledTooltip>
    </>
  );
};

export default ProfileComponent;
